export const formatCurrency = (number, options = {}) => {
  const config = {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    decimals: true,
  };

  const value = parseFloat(number, 10);
  const opt = { ...config, ...options };
  const lang = options.lang ? options.lang : 'en-GB';

  if (opt.decimals === 'optional') {
    const fraction = new Intl.NumberFormat(lang, opt)
      .formatToParts(value)
      .find(({ type }) => type === 'fraction');
    return new Intl.NumberFormat(lang, {
      ...opt,
      maximumFractionDigits: Number(fraction?.value) !== 0 ? opt.maximumFractionDigits : 0,
      minimumFractionDigits: Number(fraction?.value) !== 0 ? opt.minimumFractionDigits : 0,
    })
      .format(value)
      .trim();
  }

  return new Intl.NumberFormat(lang, {
    ...opt,
    maximumFractionDigits: opt.decimals ? opt.maximumFractionDigits : 0,
    minimumFractionDigits: opt.decimals ? opt.minimumFractionDigits : 0,
  })
    .format(value)
    .trim();
};

export const formatNumber = (number, options = {}) => {
  const config = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  };

  // https://github.com/unicode-org/cldr/blob/master/common/validity/unit.xml
  // list of unit types
  const value = parseFloat(number, 10);
  const opt = { ...config, ...options };
  const lang = options.lang ? options.lang : 'en-GB';

  return new Intl.NumberFormat(lang, opt).format(value).trim();
};

export const formatUnit = (number, options = {}) => {
  const config = {
    style: 'unit',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  };

  // https://github.com/unicode-org/cldr/blob/master/common/validity/unit.xml
  // list of unit types
  const value = parseFloat(number, 10);
  const opt = { ...config, ...options };
  const lang = options.lang ? options.lang : 'en-GB';
  const rawUnit = opt.unit;

  switch (rawUnit) {
    case 'miles':
      opt.unit = 'mile';
      opt.unitDisplay = 'long';
      break;
    case 'km':
      opt.unit = 'kilometer';
      break;
    case 'mph':
      opt.unit = 'mile-per-hour';
      break;
    case 'kmph':
      opt.unit = 'kilometer-per-hour';
      break;
    case 'mpg':
      opt.unit = 'mile-per-gallon';
      break;
    case 'g/km':
      opt.unit = 'gram-per-kilometer';
      break;
    default: break;
  }

  try {
    return new Intl.NumberFormat(lang, opt).format(value).trim();
  } catch {
    return `${value} ${rawUnit}`;
  }
};
